import React, { useState, useEffect } from "react";
import '../styles/other.css';
import '../styles/pages.css';
import Axios from 'axios';
import CsvDownloadButton from 'react-json-to-csv';

// import utilities
import { moreRecordsOnPageUtilities, lessRecordsOnPageUtilities, goToPrevPageUtilities, goToNextPageUtilities, goToFirstPageUtilities, goToLastPageUtilities, checkIfOutOfPages } from '../utilities/PagingUtilities.js';
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';

// import components
import SubmissionsTile from '../tiles/SubmissionsTile.js';

function storageEventHandler() {
    this.setState({ recordsOnOnePage: localStorage.getItem("recordsOnOnePageSubmissions") || 25 });
    this.setState({ actualPage: localStorage.getItem("actualPageSubmissions") || 0 });
    this.setState({ sortBy: localStorage.getItem("sortBySubmissions") || 0 });
    this.setState({ sortTp: localStorage.getItem("sortTpSubmissions") || 0 });
}

class ListSubmissions extends React.Component {
    setActualSection = this.props.setActualSection;

    constructor(props) {
        super(props);

        this.state = {
            /*submissionsData: ([]),*/
            submissionsData: ([{id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Balance Sheet"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "-50500", stat_type: "Balance Sheet"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Balance Sheet"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Profit & Loss"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Balance Sheet"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Profit & Loss"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Profit & Loss"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Profit & Loss"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Profit & Loss"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Profit & Loss"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Profit & Loss"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Profit & Loss"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Profit & Loss"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Profit & Loss"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Profit & Loss"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Profit & Loss"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Profit & Loss"},
                            {id: 3, period: 2024, nt_org: "KAM - Czech Republic", income: "50500", stat_type: "Balance Sheet"}]),
            recordsOnOnePage: localStorage.getItem("recordsOnOnePageSubmissions") || 25, // number of submissions showing on one page, 25 is default
            totalNumberOfContacts: 0,
            noRecordsFound: false,
            actualPage: localStorage.getItem("actualPageSubmissions") || 0, // starts with pageNumber=0, then 1, 2, 3,...
            sortBy: localStorage.getItem("sortBySubmissions") || "", // name
            sortTp: localStorage.getItem("sortTpSubmissions") || "asc", // asc, desc
            listOfNatOrg: ([{id:1, label: "Organization 1"},{id:2, label: "Organization 2"},{id:3, label: "Organization 3"}]),
            listOfStatTypes: ([{id:1, label: "StatType 1"},{id:2, label: "StatType 2"},{id:3, label: "StatType 3"}]),
            listOfPeriods: ([{id:1, label: "Period 1"},{id:2, label: "Period 2"},{id:3, label: "Period 3"}]),
            selectedPeriod: 0,
            selectedStatType: 0,
            selectedNatOrg: 0,
        }

    }

    componentDidMount(){
        this.loadData();
        window.addEventListener('storage', storageEventHandler, false);
        this.setActualSection("submissions");
    }

    componentDidUpdate(prevProps, prevState) {
    }

    loadData = async () => {
        // if user lowers the rowsPerPage, goes next page and then highers the rowsPerPage it will take him to the last page
        if(checkIfOutOfPages(this.state.actualPage, this.state.recordsOnOnePage, this.state.totalNumberOfContacts)){
            this.goToLastPage();
            return;
        }

        this.setState({ noRecordsFound: false });
        this.setState({ submissionsData: ([]) });
        this.setState({ totalNumberOfContacts: 0 });

        //var getOnlyMyContacts = this.props.allOrMy == "my" ? 1 : 0;
        var url = '/api/subm/get?limit='+this.state.recordsOnOnePage+'&offset='+(this.state.actualPage*this.state.recordsOnOnePage);
        if(this.state.sortBy != ""){
            url = url + "&sort_by="+this.state.sortBy+"&sort_tp="+this.state.sortTp;
        }
        if(this.state.selectedNatOrg != 0){
            url = url + "&nt_org="+this.state.selectedNatOrg;
        }
        if(this.state.selectedStatType != 0){
            url = url + "&stmt_tp="+this.state.selectedStatType;
        }
        if(this.state.selectedPeriod != 0){
            url = url + "&period="+this.state.selectedPeriod;
        }
        Axios.get(url).then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ submissionsData: response.data.result });
            this.setState({ totalNumberOfContacts: response.data.msg.cnt });
            if(response.data.result.length == 0){ this.setState({ noRecordsFound: true }); }

            // save the ids array to memory
            var idsArray = response.data.result.map(a => a.id);
            localStorage.setItem('idsArray', JSON.stringify(idsArray));
        });

        await this.loadNatOrg();
        await this.loadStatTypes();
        await this.loadPeriods();
    }

    loadNatOrg = () => {
        Axios.get('/api/nt_org/get').then(response => {
            this.setState({ listOfNatOrg: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ listOfNatOrg: response.data.result });
        });
    }

    loadStatTypes = () => {
        Axios.get('/api/stmt_tp/get').then(response => {
            this.setState({ listOfStatTypes: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ listOfStatTypes: response.data.result });
        });
    }

    loadPeriods = () => {
        Axios.get('/api/period/get').then(response => {
            this.setState({ listOfPeriods: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ listOfPeriods: response.data.result });
        });
    }

    goToFirstPage = async () => {
        await this.setState({ actualPage: goToFirstPageUtilities(this.state.actualPage, "actualPageSubmissions") });
        this.loadData();
    }

    goToPrevPage = async () => {
        await this.setState({ actualPage: goToPrevPageUtilities(this.state.actualPage, "actualPageSubmissions") });
        this.loadData();
    }

    goToNextPage = async () => {
        await this.setState({ actualPage: goToNextPageUtilities(this.state.actualPage, this.state.recordsOnOnePage, this.state.totalNumberOfContacts, "actualPageSubmissions") });
        this.loadData();
    }

    goToLastPage = async () => {
        await this.setState({ actualPage: goToLastPageUtilities(this.state.recordsOnOnePage, this.state.totalNumberOfContacts, "actualPageSubmissions") });
        this.loadData();
    }

    moreRecordsOnPage = async () => {
        await this.setState({ recordsOnOnePage: moreRecordsOnPageUtilities(this.state.recordsOnOnePage, "recordsOnOnePageSubmissions") });
        this.loadData();
    }

    lessRecordsOnPage = async () => {
        await this.setState({ recordsOnOnePage: lessRecordsOnPageUtilities(this.state.recordsOnOnePage, "recordsOnOnePageSubmissions") });
        this.loadData();
    }

    changeSorting = async (attribute) => {
        this.goToFirstPage();
        if(this.state.sortBy == attribute && this.state.sortTp == "asc") {
            localStorage.setItem("sortTpSubmissions", "desc");
            await this.setState({ sortTp: "desc" });
        }
        else if(this.state.sortBy == attribute && this.state.sortTp == "desc") {
            localStorage.setItem("sortBySubmissions", "");
            localStorage.setItem("sortTpSubmissions", "desc");
            await this.setState({ sortBy: "" });
            await this.setState({ sortTp: "desc" });
        }
        else {
            localStorage.setItem("sortBySubmissions", attribute);
            localStorage.setItem("sortTpSubmissions", "asc");
            await this.setState({ sortBy: attribute });
            await this.setState({ sortTp: "asc" });
        }
        this.loadData();
    }

    onNatOrgSelected = async (id) => {
        await this.setState({ selectedNatOrg: id });
        this.loadData();
    }

    onStatTypeSelected = async (id) => {
        await this.setState({ selectedStatType: id });
        this.loadData();
    }

    onPeriodSelected = async (id) => {
        await this.setState({ selectedPeriod: id });
        this.loadData();
    }

    render() {
        return (
            <div className="verticalStack flex" style={{height: "calc(100vh - 80px)"}}>
                <div className="horizontalStackCenter universalTableListingBar">
                    <span onClick={this.goToFirstPage} className="fontPoppinsSemiBold16 clickable onHoverToOrange">{"<<"}</span>
                    <span onClick={this.goToPrevPage} className="fontPoppinsSemiBold16 clickable onHoverToOrange" style={{paddingLeft: "20px"}}>{"<"}</span>
                    <span className="fontPoppinsRegular13Gray" style={{paddingLeft: "20px", paddingRight: "12px"}}>{" Submissions"}</span>
                    <span className="fontPoppinsSemiBold16">{(this.state.actualPage*this.state.recordsOnOnePage)+1}{"-"}{(this.state.actualPage+1)*this.state.recordsOnOnePage > this.state.totalNumberOfContacts ? this.state.totalNumberOfContacts : (this.state.actualPage+1)*this.state.recordsOnOnePage }</span>
                    <span className="fontPoppinsRegular13Gray" style={{paddingLeft: "6px", paddingRight: "6px"}}>{"of"}</span>
                    <span className="fontPoppinsSemiBold16">{this.state.totalNumberOfContacts}</span>
                    <span onClick={this.goToNextPage} className="fontPoppinsSemiBold16 clickable onHoverToOrange" style={{paddingLeft: "20px", paddingRight: "20px"}}>{">"}</span>
                    <span onClick={this.goToLastPage} className="fontPoppinsSemiBold16 clickable onHoverToOrange">{">>"}</span>
                    <div className="flex"/>
                    <CsvDownloadButton data={this.state.submissionsData} filename={"export_submissions.csv"} className="fontPoppinsRegular13Gray clickable onHoverToOrange" style={{backgroundColor: "transparent", border: "none", paddingRight: "30px"}}>Export CSV</CsvDownloadButton>
                    <span className="fontPoppinsRegular13Gray">{"Rows Per page:"}</span>
                    <span className="fontPoppinsSemiBold16" style={{paddingLeft: "10px", paddingRight: "10px"}}>{this.state.recordsOnOnePage}</span>
                    <div className="verticalStackCenter">
                        <div onClick={this.moreRecordsOnPage} className="clickable buttonPagingUp"></div>
                        <div style={{height: "3px"}}></div>
                        <div onClick={this.lessRecordsOnPage} className="clickable buttonPagingDown"></div>
                    </div>
                </div>

                {/* FILTER SUBMISSIONS */}
                <div className="universalTile" style={{marginLeft: 20, marginRight: 20, marginBottom: 20}}>

                    <div className="horizontalStack" style={{position: "relative", backgroundColor: "var(--lightest-gray)"}}>

                        <div className="verticalStack flex" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 20, paddingBottom: 20}}>
                            <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>National Organization:</span>
                            <select className="universalTextInput topMenuSelectBox" name="nt_org" id="nt_org" style={{}} value={this.state.selectedNatOrg} onChange={e => this.onNatOrgSelected(e.target.value)}>
                                <option value=""></option>
                                {this.state.listOfNatOrg.map(function (item) {
                                    return (
                                       <option value={item.id}>{item.label}</option>
                                    )
                                }.bind(this))}
                            </select>
                        </div>

                        <div className="verticalStack flex" style={{paddingLeft: 0, paddingTop: 20, paddingRight: 20}}>
                            <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Statement Type:</span>
                            <select className="universalTextInput topMenuSelectBox" name="stat_tp" id="stat_tp" style={{}} value={this.state.selectedStatType} onChange={e => this.onStatTypeSelected(e.target.value)}>
                                <option value=""></option>
                                {this.state.listOfStatTypes.map(function (item) {
                                    return (
                                       <option value={item.id}>{item.label}</option>
                                    )
                                }.bind(this))}
                            </select>
                        </div>

                        <div className="verticalStack flex" style={{paddingLeft: 0, paddingTop: 20, paddingRight: 20}}>
                            <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Period:</span>
                            <select className="universalTextInput topMenuSelectBox" name="period" id="period" style={{}} value={this.state.selectedPeriod} onChange={e => this.onPeriodSelected(e.target.value)}>
                                <option value=""></option>
                                {this.state.listOfPeriods.map(function (item) {
                                    return (
                                       <option value={item.id}>{item.label}</option>
                                    )
                                }.bind(this))}
                            </select>
                        </div>

                    </div>

                </div>

                <SubmissionsTile submissionsData={this.state.submissionsData} leftMenuOpened={this.props.leftMenuOpened} changeSorting={this.changeSorting} sortBy={this.state.sortBy} sortTp={this.state.sortTp} loadData={this.loadData} allOrMy={"all"} noRecordsFound={this.state.noRecordsFound} />
            </div>
        );
    }
}

export default ListSubmissions;
